import axios from '@/libs/axios'

export default {
  getSettlementsToPayByCustomerId(customerId) {
    return axios.get(`/public/customer/${customerId}/settlements/to-pay`)
  },
}
